import { render } from "./MoveOrdersForward.vue?vue&type=template&id=4c29cf15&scoped=true"
import script from "./MoveOrdersForward.vue?vue&type=script&lang=js"
export * from "./MoveOrdersForward.vue?vue&type=script&lang=js"

import "./MoveOrdersForward.vue?vue&type=style&index=0&id=4c29cf15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c29cf15"]])

export default __exports__